
<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch color="success" v-model="formCadastro.status" style="width:60px;">
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Tipo</span>
          <v-select
            :options="tiposBeneficios"
            name="Tipo"
            id="Tipo"
            v-model="formCadastro.idTipoBeneficio"
            v-validate="{ required: true}"
            :state="validateState('Tipo')"
            :class="validateClass('Tipo')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            type="text"
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            v-validate="{ required: true, }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Descrição</span>
          <vs-textarea
            class="w-full"
            name="Descrição"
            id="Descrição"
            v-model="formCadastro.descricao"
            :state="validateState('Descrição')"
            :danger="validateClass('Descrição')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length >0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height:auto !important"
      >
        <ul>
          <li class="mb-2" v-for="error in $validator.errors.all()" :key="error.id">{{ error }}</li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="warning" type="border" class="mr-3 mb-2" @click.stop.prevent="onReset">Cancelar</vs-button>
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idBeneficio==null?false:true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>


<!------------ START SCRIPT ------------>
<script>
import locale from "./../../locale";
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import service from "../../services";
import BotaoSubmit from "../../components/BotaoSubmit";

export default {
  props: {
    sideBar: {
      type: Boolean
    },
    dados: {
      type: Object
    }
  },
  watch: {
    dados(value) {
      this.preencheForm();
    }
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      tiposBeneficios: [],
      formCadastro: {
        status: true,
        idBeneficio: null,
        idEmpresa: null,
        idTipoBeneficio: null,
        nome: "",
        descricao: null
      }
    };
  },
  methods: {
    preencheForm() {
      console.log(this.dados);
      if (this.dados.idBeneficio) {
        this.formCadastro.idBeneficio = this.dados.idBeneficio;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.idTipoBeneficio = {
          id: this.dados.idTipoBeneficio,
          label: this.dados.tipo
        };
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.descricao = this.dados.descricao;
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = "Atualizar";
      var msgRetorno = "Dados Atualizados com sucesso";
      if (!this.formCadastro.idBeneficio) {
        action = "Adicionar";
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post("Beneficios", action, this.formCadastro)
            .then(res => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: `Operação Realizada com sucesso`,
                color: "success"
              });
              this.$emit("concluido");
            })
            .catch(error => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: "top-center",
                title: "Atenção",
                text: error,
                color: "danger"
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll("g", {}, `${model}/list/`).then(res => {
        res.data.forEach(element => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao]
          });
        });
      });
    },

    resetForm() {
      this.formCadastro = {
        status: true,
        idBeneficio: null,
        idEmpresa: null,
        idTipoBeneficio: null,
        nome: "",
        descricao: null
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit("cancel");
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    }
  },
  mounted() {
    this.buscaDadosSelects(
      "domTipoBeneficio",
      "tiposBeneficios",
      "nomeTipo",
      "idTipoBeneficio"
    );
    //this.buscaDadosSelects("domMunicipio", "cidades", "nomeCidade", "idCidade");
    this.$validator.localize("ptBr", locale);
  },
  components: {
    Datepicker,
    BotaoSubmit,
    "v-select": vSelect
  }
};
</script>
<!------------ END SCRIPT ------------>
